import styled from 'styled-components';
export const Wrapper = styled.div `
  border: 1px solid ${(props) => props.theme.gray};
  border-radius: 4px;
  margin-bottom: 10px;
`;
export const BaseStyles = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  @media ${(props) => props.theme.md} {
    flex-direction: row;
    justify-content: space-between;
  }
`;
export const Left = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  max-width: 50%;
  .receiver-type {
    display: flex;
    font-size: ${(props) => props.theme.fontXXXSmall};
    text-transform: uppercase;
    margin: 5px 0;
    .icon {
      margin-right: 5px;
    }
  }
  .receiver-name {
    font-size: ${(props) => props.theme.fontSmall};
    font-weight: ${(props) => props.theme.bold};
    word-break: break-word;
  }
  .delivery-box {
    font-size: ${(props) => props.theme.fontXXSmall};
  }
  @media ${(props) => props.theme.md} {
    align-items: flex-start;
  }
`;
export const Comment = styled.div `
  padding: 0 10px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media ${(props) => props.theme.md} {
    align-items: flex-start;
  }
`;
